/* TGGCore: drill-down mobile menu for the TGG mega menu.
   Event delegation only — no dependency on theme JS, survives
   section reloads and instant-click page swaps. Markup contract:
   #mobile_menu > li[data-tgg-panel-open=<handle>] root rows and
   #mobile_menu > li.tgg-mm-panel[data-tgg-panel=<handle>] panels
   (TGGCore: panels arrive in <template data-tgg-mm-panels> and are
   stamped on first drawer interaction, see stampPanels). */
(function () {
  function menuEl() {
    return document.getElementById('mobile_menu');
  }

  function closeAll(menu) {
    menu.classList.remove('tgg-mm-panel-active');
    var panels = menu.querySelectorAll('.tgg-mm-panel');
    for (var i = 0; i < panels.length; i++) panels[i].hidden = true;
  }

  function scrollDrawerTop(menu) {
    var header = document.getElementById('header');
    if (header) header.scrollTop = 0;
    var container = menu.closest('.mobile-menu-container');
    if (container) container.scrollTop = 0;
  }

  /* TGGCore: perf. snippets/tgg-mobile-menu.liquid renders the drill-down
     panels (~600 of the drawer's ~720 elements) inside an inert
     <template data-tgg-mm-panels>, so they add nothing to the live DOM on
     page load. Stamp them back in, at the template's position, on the first
     touch, focus or click anywhere in the drawer (capture phase, so it runs
     before the drawer opens and before the row handler below). Everything
     that drives the panels is delegated and looks them up at event time, so
     nothing needs re-binding. Idempotent: a header re-rendered by the theme
     editor brings a fresh template, stamped on its next interaction. */
  function stampPanels(menu) {
    if (!menu) return;
    var tpls = menu.querySelectorAll('template[data-tgg-mm-panels]');
    for (var i = 0; i < tpls.length; i++) {
      var tpl = tpls[i];
      if (tpl.content && tpl.parentNode) tpl.parentNode.replaceChild(tpl.content, tpl);
    }
  }

  function stampFromEvent(e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-mobile-menu]')) stampPanels(menuEl());
  }

  ['pointerdown', 'touchstart', 'focusin', 'click'].forEach(function (type) {
    document.addEventListener(type, stampFromEvent, { capture: true, passive: true });
  });

  document.addEventListener('click', function (e) {
    var menu = menuEl();
    if (!menu) return;

    var opener = e.target.closest('[data-tgg-panel-open]');
    if (opener && menu.contains(opener)) {
      e.preventDefault();
      closeAll(menu);
      var handle = opener.getAttribute('data-tgg-panel-open');
      var panel = menu.querySelector('[data-tgg-panel="' + handle + '"]');
      /* TGGCore: belt and braces; the capture listener above stamps first */
      if (!panel) {
        stampPanels(menu);
        panel = menu.querySelector('[data-tgg-panel="' + handle + '"]');
      }
      if (panel) {
        panel.hidden = false;
        menu.classList.add('tgg-mm-panel-active');
        scrollDrawerTop(menu);
      }
      return;
    }

    var back = e.target.closest('[data-tgg-panel-back]');
    if (back && menu.contains(back)) {
      e.preventDefault();
      closeAll(menu);
      scrollDrawerTop(menu);
    }
  });

  /* Header v2: inline expanding search — .is-open animates the pill out of
     the magnifier's spot (see tgg-mega-menu.css) */
  function setSearchOpen(row, open) {
    row.classList.toggle('is-open', open);
    var toggles = document.querySelectorAll('[data-tgg-search-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].setAttribute('aria-expanded', String(open));
    }
    /* collapse the main bar's utility links while the pill is expanded there */
    var main = document.querySelector('.tgg-hv2__main');
    if (main) main.classList.toggle('tgg-hv2--search-open', open && main.contains(row));
    /* hide the sticky bar's faux search field while the real one is docked
       below it — two visible search boxes reads as a glitch */
    var bar = stickyBar();
    if (bar) bar.classList.toggle('tgg-hv2--dock-open', open && bar.contains(row));
    if (open) {
      var input = row.querySelector('input[type="search"], input[name="q"]');
      if (input) input.focus({ preventScroll: true });
    }
  }

  /* From the sticky bar, the real search field (not a clone — cloned forms
     lose the theme's predictive-search bindings) is moved into the pinned
     bar and docked as a full-width row below it, then moved home again. */
  function stickyBar() {
    return document.querySelector('.sticky_nav');
  }

  function restoreSearchRow(row) {
    if (row._tggHome && row.parentNode !== row._tggHome.parent) {
      row._tggHome.parent.insertBefore(row, row._tggHome.next);
    }
  }

  function dockSearchRowInSticky(row) {
    var bar = stickyBar();
    if (!bar) return false;
    if (!row._tggHome) row._tggHome = { parent: row.parentNode, next: row.nextSibling };
    if (row.parentNode !== bar) bar.appendChild(row);
    if (!row._tggStickyWatch) {
      /* When the bar unpins (scrolled back up), close and send the field home */
      row._tggStickyWatch = new MutationObserver(function () {
        if (!bar.classList.contains('sticky_nav--stick') && row.parentNode === bar) {
          setSearchOpen(row, false);
          restoreSearchRow(row);
        }
      });
      row._tggStickyWatch.observe(bar, { attributes: true, attributeFilter: ['class'] });
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    var row = document.querySelector('[data-tgg-search-row]');
    if (!row) return;
    var toggle = e.target.closest('[data-tgg-search-toggle]');
    if (toggle) {
      e.preventDefault();
      var fromSticky = !!toggle.closest('.sticky_nav');
      var isOpen = row.classList.contains('is-open');
      if (fromSticky) {
        if (isOpen && row.parentNode === stickyBar()) {
          setSearchOpen(row, false);
          restoreSearchRow(row);
        } else {
          dockSearchRowInSticky(row);
          setSearchOpen(row, true);
        }
      } else {
        restoreSearchRow(row);
        setSearchOpen(row, !isOpen);
      }
      return;
    }
    if (row.classList.contains('is-open') && !e.target.closest('[data-tgg-search-row]')) {
      setSearchOpen(row, false);
      restoreSearchRow(row);
    }
  });

  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape') return;
    var row = document.querySelector('[data-tgg-search-row]');
    if (row && row.classList.contains('is-open')) {
      setSearchOpen(row, false);
      restoreSearchRow(row);
      var btn = document.querySelector('[data-tgg-search-toggle]');
      if (btn) btn.focus();
    }
  });

  /* Header v2: currency dropdown open/close belongs to the theme's own
     disclosure JS (utils.enableDisclosure binds every [data-disclosure] at
     app init: hover-open, mouseleave/Esc-close). Don't double-drive it —
     we only close it ourselves right after a currency pick below. */
  function closeLocDropdown() {
    var open = document.querySelector('.tgg-hv2__loc [data-disclosure-toggle].is-clicked');
    if (open) {
      open.classList.remove('is-clicked');
      open.setAttribute('aria-expanded', 'false');
    }
  }

  /* Reset to the root list whenever the drawer itself closes */
  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-mobile-menu]') && !e.target.open) {
      var menu = menuEl();
      if (menu) closeAll(menu);
    }
  }, true);

  /* Header v2: default the display currency to the market's (USD on the US
     market, CAD elsewhere). The theme's display-only converter
     (currencies.js) initialises from localStorage or the CAD default; the
     market only sets the default — a currency the visitor picked in the
     header switcher is stored per-domain and wins on return visits.
     Checkout still charges CAD — this only changes what's displayed. */
  (function syncMarketCurrency() {
    var host = document.querySelector('[data-tgg-display-currency]');
    if (!host) return;
    var stored = null;
    try { stored = window.localStorage.getItem('currency'); } catch (err) { stored = null; }
    if (stored) return;
    var target = host.getAttribute('data-tgg-display-currency');
    var tries = 0;
    (function attempt() {
      var cc = window.currencyConverter;
      if (cc && cc.isInitialised) {
        if (cc.currentCurrency !== target) cc.setCurrency(target);
        return;
      }
      if (tries++ < 40) setTimeout(attempt, 250);
    })();
  })();

  /* TGGCore: the currency lists tick the store's own currency (Liquid marks
     CAD as current) and the converter never moves the tick, so after a
     shopper picked USD the menu still ticked CAD. Keep the tick on the
     display currency: every switch goes through the converter's
     _convertAll (a pick, the market default above, page swaps), so follow
     it there. Header, mobile menu and footer lists alike. */
  (function syncCurrencyTick() {
    function tick(cur) {
      var btns = document.querySelectorAll('[data-currency-converter] .disclosure__button');
      for (var i = 0; i < btns.length; i++) {
        var on = btns[i].value === cur, li = btns[i].closest('.disclosure-list__item');
        if (li) li.classList.toggle('disclosure-list__item--current', on);
        if (on) btns[i].setAttribute('aria-current', 'true'); else btns[i].removeAttribute('aria-current');
      }
    }
    var tries = 0;
    (function attempt() {
      var cc = window.currencyConverter;
      if (cc && cc.isInitialised && typeof cc._convertAll === 'function') {
        if (!cc._convertAll.tggTick) {
          var convertAll = cc._convertAll;
          cc._convertAll = function (cur) {
            var out = convertAll.apply(this, arguments);
            tick(cur);
            return out;
          };
          cc._convertAll.tggTick = true;
        }
        tick(cc.currentCurrency);
        return;
      }
      if (tries++ < 40) setTimeout(attempt, 250);
    })();
  })();

  /* TGGCore: mobile cart badge. The theme's ajax cart writes the raw count
     straight into .cart_count (app.js refreshCart) and never touches
     classes, so the badge would keep showing a "0" pill after the last
     item is removed. Mirror the Liquid-rendered is-empty state on every
     count change so an empty cart leaves the bar as uniform line art. */
  (function syncMobileCartBadge() {
    var badge = document.querySelector('[data-tgg-cart-badge]');
    if (!badge || !window.MutationObserver) return;
    function sync() {
      var count = parseInt((badge.textContent || '').replace(/[^0-9]/g, ''), 10);
      badge.classList.toggle('is-empty', !count);
    }
    new MutationObserver(sync).observe(badge, {
      childList: true,
      characterData: true,
      subtree: true,
    });
    sync();
  })();

  /* The converter's own click handler stopPropagation()s, so the loc
     dropdown never sees the document click that would close it — close it
     ourselves from the capture phase when a currency option is picked */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.tgg-hv2__loc .disclosure-list .disclosure__button')) {
      setTimeout(closeLocDropdown, 0);
    }
  }, true);
})();
